export const NOTIFICATION_LIST_ATTEMPT = "NOTIFICATION_LIST_ATTEMPT";
export const NOTIFICATION_LIST_SUCCESS = "NOTIFICATION_LIST_SUCCESS";
export const NOTIFICATION_LIST_FAILED = "NOTIFICATION_LIST_FAILED";
////////////
export const NOTIFICATION_MORELIST_ATTEMPT = "NOTIFICATION_MORELIST_ATTEMPT";
export const NOTIFICATION_MORELIST_SUCCESS = "NOTIFICATION_MORELIST_SUCCESS";
export const NOTIFICATION_MORELIST_FAILED = "NOTIFICATION_MORELIST_FAILED";
/////////////
export const NOTIFICATION_SET_COUNT = "NOTIFICATION_SET_COUNT";
export const NOTIFICATION_MARK_ALL_READ_SUCCESS = "NOTIFICATION_MARK_ALL_READ_SUCCESS";

